<template>
  <div class="body">
    <header class="header">
      <div class="back" @click="backIndex">
        <img src="../../assets/images/login/DL-icon-back@2x.png" alt="" />
        <span>返回首页</span>
      </div>
      <div class="logo">
        <img src="../../assets/images/login/DL_logo@2x.png" alt="" />
      </div>
    </header>

    <div class="container" style="transform: scale(0.7);margin-top: -50px;">
      <h1>用户登录</h1>
      <a-form :form="form">
        <a-form-item>
          <div class="input">
            <label for="mobile">
              <img
                src="../../assets/images/login/DL_icon1-user@2x.png"
                alt=""
              />
              <span>登录账号：</span>
            </label>
            <a-input
              v-decorator="[
                'mobile',
                {
                  rules: [{ required: true, message: '账号为必填' }],
                },
              ]"
              placeholder="请输入登录账号"
              type="text"
            ></a-input>
          </div>
        </a-form-item>

        <a-form-item>
          <div class="input">
            <label for="password">
              <img
                src="../../assets/images/login/DL_icon2-mima@2x.png"
                alt=""
              />
              <span>登录密码：</span>
            </label>
            <a-input
              v-decorator="[
                'password',
                {
                  rules: [{ required: true, message: '密码为必填' }],
                },
              ]"
              placeholder="请输入登录密码"
              :type="passwordType"
            ></a-input>
            <img
              @click="changeVisible"
              style="width: 22px; height: 14px"
              :src="passwordVisible_img"
              alt=""
            />
          </div>
        </a-form-item>
      </a-form>
      <div class="policy">
        <img @click="changeChecked" :src="checked_img" alt="" />
        <span>我同意用户协议和隐私政策</span>
      </div>
      <div class="login_btn">
        <input type="button" @click="submit" value="登录" />
      </div>

      <div class="skips">
        <span @click="toReg">没有账号，去注册</span>
        <span @click="toFindPwd">忘记密码</span>
      </div>
    </div>
  </div>
</template>

<script>
import UsersServices from "../../xx-vue/services/user";
import Storage from "../../xx-vue/utils/storage";
export default {
  data() {
    return {
      passwordVisible: true, //密码状态
      passwordVisible_img: require("../../assets/images/login/DL-visible2@2x.png"), //眼睛路径
      passwordType: "password", //密码type
      checked: true, //单选框状态
      checked_img: require("../../assets/images/login/DL_xieyi-2@2x.png"), //单选框路径
    };
  },
  //初始化表单
  beforeCreate() {
    this.form = this.$form.createForm(this, { name: "loginForm" });
  },
  //注册跳转到登录时获取账号
  mounted() {
    if (this.$route.params.mobile) {
      this.form.setFieldsValue({ mobile: this.$route.params.mobile });
    }
  },
  methods: {
    //返回首页
    backIndex() {
      this.$router.push("/");
    },
    //显示/隐藏密码
    changeVisible() {
      this.passwordVisible = !this.passwordVisible;
      if (this.passwordVisible === true) {
        this.passwordVisible_img = require("../../assets/images/login/DL-visible2@2x.png");
        this.passwordType = "password";
      } else {
        this.passwordVisible_img = require("../../assets/images/login/DL_visible@2x.png");
        this.passwordType = "text";
      }
    },
    //同意/拒绝用户协议
    changeChecked() {
      this.checked = !this.checked;
      if (this.checked) {
        this.checked_img = require("../../assets/images/login/DL_xieyi-2@2x.png");
      } else {
        this.checked_img = require("../../assets/images/login/DL_xieyi-1@2x.png");
      }
    },
    //跳转至注册
    toReg() {
      this.$router.push("/register");
    },
    //跳转至找回密码
    toFindPwd() {
      this.$router.push("/find_password");
    },
    //登录
    submit(e) {
      e.preventDefault();
      this.form.validateFields(async (err, values) => {
        if (!err) {
          if (this.checked) {
            const result = await UsersServices.loginAsync(values);
            if (result.code === 200) {
              Storage.setStorage(result.data); //存储token及用户信息
              this.$message.success("登录成功！");
              setTimeout(() => {
                var query = this.$route.query || {};
                if(query.url){
                  this.$router.push(decodeURIComponent(query.url));
                }else{
                  this.$router.push("/");
                }
                
              }, 1000);
            }
          } else {
            this.$message.error(`请先勾选并同意用户协议和隐私政策`);
          }
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
/deep/ .ant-form-explain {
  text-align: right;
  margin-bottom: 10px;
}
.ant-input {
  border: none;
  font-size: 16px;
  color: #989898;
}

.ant-input:focus {
  box-shadow: none;
}

.body {
  width: 100%;
  height: 100%;
  position: fixed;
  background: url("../../assets/images/login/DL-bg@2x.png") no-repeat;
  background-size: 100% 100%;
  .back {
    cursor: pointer;
    display: flex;
    align-items: center;
    color: #ffffff;
    padding: 15px 30px;
    font-size: 14px;
    img {
      width: 30px;
      height: 30px;
      margin-right: 8px;
    }
  }

  .logo {
    width: 140px;
    height: 100px;
    margin: 0 auto;
    margin-bottom: 20px;
    img {
      width: 100%;
      height: 100%;
    }
  }

  .container {
    width: 940px;
    height: 680px;
    padding: 56px 240px 164px 240px;
    box-sizing: border-box;
    background-color: #ffffff;
    margin: 0 auto;
    h1 {
      color: #333333;
      font-size: 20px;
      font-family: "Microsoft YaHei Regular";
      font-weight: normal;
      text-align: center;
      position: relative;
      margin-bottom: 58px;

      &::before {
        content: "";
        display: block;
        position: absolute;
        width: 120px;
        height: 1px;
        background-color: #c7b7b7;
        top: 16px;
        left: 0;
      }

      &::after {
        content: "";
        display: block;
        position: absolute;
        width: 120px;
        height: 1px;
        background-color: #c7b7b7;
        top: 16px;
        right: 0;
      }
    }

    .input {
      padding: 16px 16px;
      background-color: #f2f2f2;
      display: flex;
      align-items: center;

      & > img {
        width: 20px;
        height: 14px;
        cursor: pointer;
      }

      label {
        display: flex;
        align-items: center;
        img {
          width: 22px;
          height: 24px;
          margin-right: 10px;
        }

        span {
          font-size: 14px;
          font-family: "Microsoft YaHei Regular";
          user-select: none;
        }
      }

      input {
        height: 32px;
        flex: 1;
        outline: none;
        border: none;
        text-indent: 16px;
        background-color: #f2f2f2;
      }
    }

    .policy {
      display: flex;
      align-items: center;
      margin-bottom: 10px;
      margin-top: 30px;
      img {
        width: 16px;
        height: 16px;
        cursor: pointer;
      }
      span {
        margin-left: 6px;
        color: #989898;
        font-size: 14px;
        user-select: none;
      }
    }

    .login_btn {
      margin-bottom: 20px;
      input {
        width: 100%;
        height: 50px;
        border: none;
        border-radius: 4px;
        background-color:#a32225;
        color: #ffffff;
        cursor: pointer;
        outline: none;
      }
    }

    .skips {
      color: #a32225;
      display: flex;
      justify-content: space-between;
      span {
        cursor: pointer;
      }
    }
  }
}
</style>